import { useEffect } from 'react';
import useTermStore from '../store/cmsStore/termStore';
import Seo from '../components/Seo';


const linkifyEmail = (html: string) => {
  if (!html || html.includes('mailto:slammmm.com@gmail.com')) return html;
  return html.replace(
    /slammmm\.com@gmail\.com/g,
    '<a href="mailto:slammmm.com@gmail.com">slammmm.com@gmail.com</a>'
  );
};

const Privacy = () => {
  const {staticpage, fetchStaticPageContent } = useTermStore();


  useEffect(() => {
    window.scrollTo(0, 0);
    fetchStaticPageContent(1);
  }, [fetchStaticPageContent]);



  return (
<>
        <Seo
          title="Privacy Policy | How SLAMMMM Protects Your Personal Data"
          description="Read SLAMMMM's Privacy Policy to learn how we collect, use, store, and protect your personal information while ensuring a safe and secure experience."
        />
{staticpage.content && (
    <div className="mb-0" dangerouslySetInnerHTML={{ __html: linkifyEmail(staticpage.content) }}></div>

)}
</>
);
};


export default Privacy;